import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.25 4.535A9.7 9.7 0 0 0 6 3.002a9.7 9.7 0 0 0-3.25.555.75.75 0 0 0-.5.707v14.25a.75.75 0 0 0 1 .708 8.2 8.2 0 0 1 2.75-.47c1.995 0 3.823.708 5.25 1.886zm1.5 16.103A8.2 8.2 0 0 1 18 18.752c.966 0 1.89.166 2.75.47a.75.75 0 0 0 1-.708V4.264a.75.75 0 0 0-.5-.707A9.7 9.7 0 0 0 18 3.002a9.7 9.7 0 0 0-5.25 1.533z"
    }, null, -1)
  ])))
}
export default { render: render }